<template>
   <main>
      <div class="breadcrumb">
      <div class="container">
          <ul>
              <li><router-link to="/">HARUMIFLAG</router-link></li>
              <li><router-link to="/NotFound">このページは利用できません</router-link></li>
          </ul>
      </div>
      </div>
      <div class="cms">
          <div class="container">
              <div class="cms-cont">
                  <h2>このページは利用できません。</h2>
                  <div class="cms-cont__top">
                      <p style="text-align: center;">申し訳ございません。<br>
                        ご指定のページは現在ご利用できません。<br>
                        削除されたか、ご入力頂いたURLが間違っている可能性があります。</p>
                  </div>
              </div>
          </div>
      </div>
    </main>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: 'NotFound',
  components: {
  }
}
</script>
